import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18PinB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      d: "M6.88 3.309a.886.886 0 0 1 1.249.109l2.143 2.554c.088.106.2.189.326.244l2.128.922a.886.886 0 0 1 .217 1.491l-1.868 1.568 2.38 2.837.14.671a.2.2 0 0 1-.27.227l-.635-.255-2.381-2.837-1.956 1.641a.886.886 0 0 1-1.431-.473l-.539-2.256A.9.9 0 0 0 6.2 9.39L4.057 6.834a.886.886 0 0 1 .109-1.248z"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18PinB$1 = Svg18PinB;

export { Svg18PinB$1 as default };
